var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 24
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "#fff",
  fillOpacity: 0.05,
  rx: 18
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A0A9BE",
  d: "M18 9.667A8.334 8.334 0 0 1 26.334 18l-.01.429A8.335 8.335 0 0 1 18 26.334l-.429-.01A8.335 8.335 0 0 1 18 9.666m0 1.25a7.083 7.083 0 1 0 0 14.167 7.083 7.083 0 0 0 0-14.167m.278 1.673A5.417 5.417 0 0 1 23.416 18l-.007.278A5.417 5.417 0 0 1 18 23.416l-.28-.007a5.42 5.42 0 0 1-5.13-5.13L12.583 18A5.42 5.42 0 0 1 18 12.583zM18 13.833a4.167 4.167 0 1 0 0 8.332 4.167 4.167 0 0 0 0-8.332m0 2.084a2.083 2.083 0 1 1 0 4.166 2.083 2.083 0 0 1 0-4.166"
}))));
export default SvgTarget;